<template>
    <div class="md:grid md:grid-cols-12 wrapper-page">
        <div class="col-start-1 col-span-5 px-5">
            <slot name="about" />
        </div>
        <div class="col-start-7 col-span-7 md:mt-5 pl-5 py-5 md:py-0 space-y-3 md:space-y-5">
            <slot name="asideContent" />
        </div>
    </div>
</template>
